"use strict";
// Copyright © Veeam Software Group GmbH
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CopyButton = void 0;
const react_1 = __importDefault(require("react"));
const components_1 = require("@veeam/components");
const CopyToClipboard_svg_1 = __importDefault(require("@veeam/uikit-assets/src/icons/common/CopyToClipboard/CopyToClipboard.svg"));
const FeatureContext_1 = require("../../core/contexts/FeatureContext");
const helpers_1 = require("../../helpers");
require("./types");
const CopyButton = ({ data, isDisabled, onCopy, dataMapper, texts, }) => {
    const { t } = FeatureContext_1.useFeatureContext();
    const { handleCopy, isCopyingDoneShown } = helpers_1.useCopyData({
        data,
        onCopy,
        dataMapper,
    });
    return (react_1.default.createElement(components_1.StackView, { direction: components_1.STACK_DIRECTION.row, gap: components_1.STACK_GAP.m },
        react_1.default.createElement(components_1.Button, { ui: components_1.BUTTON_VIEW.text, disabled: isDisabled, onClick: () => {
                handleCopy();
            } },
            react_1.default.createElement(components_1.Icon, { src: CopyToClipboard_svg_1.default }),
            (texts === null || texts === void 0 ? void 0 : texts.buttonLabel) || t('copyButton|copyToClipboard|label')),
        isCopyingDoneShown && (react_1.default.createElement(components_1.Notification, { status: components_1.NOTIFICATION_STATUS.ok }, (texts === null || texts === void 0 ? void 0 : texts.notificationDoneMessage) || t('copyButton|copyToClipboard|message')))));
};
exports.CopyButton = CopyButton;
//# sourceMappingURL=CopyButton.js.map